import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

// Recursively rewrite any absolute "https://<host>/api/..." asset URL in API
// responses to a relative same-origin path. This fixes broken product images on
// the live custom domain where records still hold preview-domain media URLs.
const _rewriteSameOrigin = (val) => {
  if (typeof val === "string") {
    const m = val.match(/^https?:\/\/[^/]+(\/api\/.*)$/i);
    return m ? m[1] : val;
  }
  if (Array.isArray(val)) return val.map(_rewriteSameOrigin);
  if (val && typeof val === "object") {
    for (const k in val) val[k] = _rewriteSameOrigin(val[k]);
    return val;
  }
  return val;
};
api.interceptors.response.use((resp) => {
  try { if (resp && resp.data) resp.data = _rewriteSameOrigin(resp.data); } catch { /* non-fatal */ }
  return resp;
});

// Absolute URL to a stored media asset (usable in <img>/<audio> src).
export const mediaUrl = (assetId) => (assetId ? `${API}/media/${assetId}` : "");

// Normalise media/asset URLs to the CURRENT site origin. Older records may store
// an absolute URL pointing at a different environment (e.g. the preview domain);
// on the live custom domain those become cross-origin and can fail to render.
// Rewriting any ".../api/<path>" to a relative "/api/<path>" makes the browser
// load it from whatever origin is serving the site (works in preview AND prod).
export const sameOriginMedia = (src) => {
  if (!src || typeof src !== "string") return src;
  const m = src.match(/^https?:\/\/[^/]+(\/api\/.*)$/i);
  return m ? m[1] : src;
};

// Turn a backend-relative path like "/api/media/xxx" into an absolute URL.
export const absUrl = (path) => (path ? `${BACKEND_URL}${path}` : "");

// Absolute URL to a brand QR PNG encoding `data`.
export const qrUrl = (data, size = 9) => `${API}/qr?data=${encodeURIComponent(data)}&size=${size}`;

// Upload a personalization photo/voice file. Returns { asset_id, kind, media_url, ... }.
export async function uploadMedia(file, kind, guestId) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  fd.append("guest_id", guestId || "");
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return data;
}

export function getGuestId() {
  let id = localStorage.getItem("wp_guest");
  if (!id) {
    id = "guest_" + Math.random().toString(36).slice(2, 11);
    localStorage.setItem("wp_guest", id);
  }
  return id;
}

export const formatINR = (n) => `₹${Math.round(Number(n) || 0).toLocaleString("en-IN")}`;
